export const pathToChapters = (path: readonly number[]) =>
  path.map((item) => item + 1).join('.');
